export const isRightAppLink = (value: string): boolean =>
  RegExp('https?://apps.apple.com.*').test(value)
